import { render } from "./DButton.vue?vue&type=template&id=d701e3d8&ts=true"
import script from "./DButton.vue?vue&type=script&lang=ts"
export * from "./DButton.vue?vue&type=script&lang=ts"

import exportComponent from "d:\\jenkins-nodes\\Atlanta\\workspace\\Atlanta-FE-Git-189PRE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__